// src/progress/ProgressSyncInit.jsx
import React, { useContext, useEffect } from "react";
import { AuthContext } from "../components/AuthContext";
import { __initProgressSync, flushQueue } from "../utils/saveProgress";
import { migrateLocalProgressForUser } from "./migrateLocalProgress";

// Komponent „starter”: podaje authorizedFetch do warstwy saveProgress (kolejki sync),
// migruje stare wpisy z localStorage -> serwer (raz per użytkownik),
// i próbuje wysłać bieżącą kolejkę po zalogowaniu. Nie renderuje nic widocznego.
export default function ProgressSyncInit() {
  const { user, isAuthReady, authorizedFetch } = useContext(AuthContext);

  // wstrzyknięcie authorizedFetch do saveProgress (kolejka)
  useEffect(() => {
    __initProgressSync(() => authorizedFetch);
  }, [authorizedFetch]);

  // po zalogowaniu: najpierw migracja, potem flush kolejki
  useEffect(() => {
    if (!isAuthReady || !user) return;

    (async () => {
      try {
        await migrateLocalProgressForUser(user.email, authorizedFetch);
      } finally {
        // nawet jeśli migracja nie wyjdzie (offline), spróbuj wysłać bieżącą kolejkę
        flushQueue();
      }
    })();
  }, [isAuthReady, user, authorizedFetch]);

  return null;
}
